import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getProfileToggleLists } from "../../API/store/actions/auth";
import { currentCommunity } from "../../API/store/actions/community";
import { Link } from "react-router-dom";
import { ScrollToTop } from "../../algorithms";
import Lang from "../../userPreferences/staticWords";
const MemberLists = ({ id }) => {
  const [data, setData] = useState([]);
  const userToken = useSelector((state) => state.login.userToken);
  const userLogged = useSelector((state) => state.login.userData);
  useEffect(() => {
    if (id)
      resolver(
        getProfileToggleLists,
        setData,
        userLogged.memberId,
        id,
        userToken
      );
    ScrollToTop();
    return null;
  }, [id]);

  const dispatch = useDispatch();

  if (data?.data)
    return (
      <div className="d-flex container col-10 py-3 mb-3">
        {data?.data?.length ? (
          <div className="d-flex flex-column justify-content-start col-12">
            {data?.data?.map((item, index) => {
              let arr = [];
              if (item?.projects) arr = item?.projects;
              else if (item?.tasks) arr = item?.tasks;
              else if (item?.forums) arr = item?.forums;
              return (
                <div key={item?.communityId} style={{ width: "fit-content" }}>
                  {item.communityName ? (
                    <div className="d-flex p-2 align-items-center">
                      <div>
                        <img src={"/assets/images/sync-1.png"} />
                      </div>
                      <div className="mx-2">{item.communityName}</div>
                    </div>
                  ) : null}
                  {arr?.length > 0 ? (
                    arr?.map((item, index) => {
                      return (
                        <Link
                          to={`/${
                            id == "A2"
                              ? "projectDetails"
                              : id == "A3"
                              ? "taskDetails"
                              : "discussion"
                          }/${item?.id}`}
                          key={item?.id}
                          onClick={() => {
                            dispatch(
                              currentCommunity({
                                id: item?.communityId,
                                name: item?.communityName,
                                logo: item?.communityLogo,
                              })
                            );
                          }}
                          className=" hoverLinks text-decoration-none"
                          style={{ width: "fit-content" }}
                        >
                          <div className="d-flex px-5 py-2 align-items-center">
                            <div>
                              {id == "A2" ? (
                                <img
                                  src={
                                    "/assets/images/icons/projection-screen.png"
                                  }
                                />
                              ) : null}
                              {id == "A3" ? (
                                <img
                                  src={"/assets/images/icons/fi-br-layers.png"}
                                />
                              ) : null}
                              {id == "A4" ? (
                                <img
                                  src={
                                    "/assets/images/icons/fi-br-comments.png"
                                  }
                                />
                              ) : null}
                            </div>
                            <div className="mx-2">
                              {id == "A2" || id == "A3"
                                ? item?.name
                                : item?.title}
                            </div>
                          </div>
                        </Link>
                      );
                    })
                  ) : (
                    <div className="d-flex justify-content-center py-4">
                      لا يوجد
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center m-auto">{Lang.noData}</div>
        )}
      </div>
    );
  return <div>{Lang.noData}</div>;
};
export default MemberLists;
